const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/auth/admin-access/ended.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { type AdminAccessEndReason } from '@/auth/auth-storage';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/auth/admin-access/ended')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
/** 대리 접속이 끝난 탭. 이 탭은 다시 쓰지 않고 닫는다. */
export function TSRDummyComponent() {
  return null;
}